export const CREATE_SYNDICATE_REQUEST = 'CREATE_SYNDICATE_REQUEST';
export const CREATE_SYNDICATE_SUCCESS = 'CREATE_SYNDICATE_SUCCESS';
export const CREATE_SYNDICATE_FAILURE = 'CREATE_SYNDICATE_FAILURE';

export const UPDATE_SYNDICATE_REQUEST = 'UPDATE_SYNDICATE_REQUEST';
export const UPDATE_SYNDICATE_SUCCESS = 'UPDATE_SYNDICATE_SUCCESS';
export const UPDATE_SYNDICATE_FAILURE = 'UPDATE_SYNDICATE_FAILURE';

export const FETCH_SYNDICATE_REQUEST = 'FETCH_SYNDICATE_REQUEST';
export const FETCH_SYNDICATE_SUCCESS = 'FETCH_SYNDICATE_SUCCESS';
export const FETCH_SYNDICATE_FAILURE = 'FETCH_SYNDICATE_FAILURE';

export const CLEAR_SYNDICATE = 'CLEAR_SYNDICATE';

export const FETCH_SYNDICATES_REQUEST = 'FETCH_SYNDICATES_REQUEST';
export const FETCH_SYNDICATES_SUCCESS = 'FETCH_SYNDICATES_SUCCESS';
export const FETCH_SYNDICATES_FAILURE = 'FETCH_SYNDICATES_FAILURE';

export const FETCH_MEMBER_SYNDICATES_REQUEST =
  'FETCH_MEMBER_SYNDICATES_REQUEST';
export const FETCH_MEMBER_SYNDICATES_SUCCESS =
  'FETCH_MEMBER_SYNDICATES_SUCCESS';
export const FETCH_MEMBER_SYNDICATES_FAILURE =
  'FETCH_MEMBER_SYNDICATES_FAILURE';

export const FETCH_MEMBER_SYNDICATE_REQUEST = 'FETCH_MEMBER_SYNDICATE_REQUEST';
export const FETCH_MEMBER_SYNDICATE_SUCCESS = 'FETCH_MEMBER_SYNDICATE_SUCCESS';
export const FETCH_MEMBER_SYNDICATE_FAILURE = 'FETCH_MEMBER_SYNDICATE_FAILURE';

export const CONFIRM_INVITATION_REQUEST = 'CONFIRM_INVITATION_REQUEST';
export const CONFIRM_INVITATION_SUCCESS = 'CONFIRM_INVITATION_SUCCESS';
export const CONFIRM_INVITATION_FAILURE = 'CONFIRM_INVITATION_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/syndicate.js